import { FC } from 'react';
import Link from 'next/link';
import Slider from 'react-slick';
import { getAuthorFullName, getTruncatedTxt, hideImgOnError } from '@/helpers/helpers';
import { DEV_ABSOLUTE_URL, otherAuthorsBooksSliderConfig } from '@/helpers/variables';
import { IBooksPageData } from '@/interfaces/booksPage.interface';
import ImgFullLabel from '../img-full-label/ImgFullLabel';
import styles from './HomeBooksSlider.module.scss';

interface IHomeBooksSlider {
  books: IBooksPageData[];
}

const HomeBooksSlider: FC<IHomeBooksSlider> = ({ books }) => {
  return (
    <>
      <div className="contentHeader">
        <div className="contentHeader__item">
          <b>Бесплатные книги</b>
        </div>
      </div>
      <div className="content">
        <div className={styles.booksSlider} id="__booksSlider">
          <Slider {...otherAuthorsBooksSliderConfig}>
            {books.map((item) => {
              const bookAlias = `/authors/${item.author.alias}/${item.alias}${item.book.allow_full_free === 1 && item.type === 'book' ? '/read' : ''}`;
              const isAudioBook = item.book.type === 'audio_book';

              return (
                <div key={item.id} className={styles.booksSlider__item}>
                  <div className={styles.booksSlider__itemImgWrap}>
                    <Link prefetch={false} href={bookAlias} className={styles.booksSlider__itemImg}>
                      <img className={styles.booksSlider__img} src={`${DEV_ABSOLUTE_URL}/covers/${item.book.external_id}.jpg`} alt="img" onError={hideImgOnError} width="130" height="194" />
                      {item.book.allow_full_free === 1 && <ImgFullLabel extraClassName="imgFullLabel_slider" />}
                    </Link>
                  </div>
                  <Link prefetch={false} href={bookAlias} className={styles.booksSlider__itemTitle}>
                    {getTruncatedTxt(item.book.title, 40)}
                  </Link>
                  <Link prefetch={false} href={`/authors/${item.author.alias}`} className={styles.booksSlider__author}>
                    {getAuthorFullName(item.author.first_name, '', item.author.last_name)}
                  </Link>
                  <Link prefetch={false} href={bookAlias} className={styles.booksSlider__btn}>
                    {isAudioBook ? 'Подробнее' : 'Читать онлайн'}
                  </Link>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </>
  );
};
export default HomeBooksSlider;
